import { render, staticRenderFns } from "./DebugControllerForm.vue?vue&type=template&id=1386adce&scoped=true&"
import script from "./DebugControllerForm.vue?vue&type=script&lang=js&"
export * from "./DebugControllerForm.vue?vue&type=script&lang=js&"
import style0 from "./DebugControllerForm.vue?vue&type=style&index=0&id=1386adce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1386adce",
  null
  
)

export default component.exports